<div
  class="flex items-center flex-1 min-w-0 gap-2 max-sm:flex-row max-sm:justify-start"
>
  <img alt="logo" [src]="getLogoImg()" class="logo-sm" />
  @if(screenService.isMobile()){
  <div class="max-w-full overflow-hidden min-w-0 block">
    <span
      class="truncate cursor-pointer hover:underline block text-wrap"
      [class.font-roboto-500]="isWin()"
      [attr.title]="getTraduccionName()"
    >
      {{ getTraduccionName() }}
    </span>
  </div>
  }@else {
  <a
    class="max-w-full overflow-hidden min-w-0 block"
    [routerLink]="getUrlTeam()"
    (click)="$event.preventDefault(); $event.stopPropagation()"
  >
    <span
      class="truncate cursor-pointer hover:underline block text-wrap"
      [class.font-roboto-500]="isWin()"
      [attr.title]="getTraduccionName()"
    >
      {{ getTraduccionName() }}
    </span>
  </a>
  }

  <div class="justify-end hidden min-w-[25px] max-sm:flex max-sm:ml-auto">
    <span class="text-end" [class.text-red-2]="isLiveMatch()">
      {{ homeTeam()?.penaltyScore && "(" + homeTeam()?.penaltyScore + ")" }}
      {{ homeTeam()?.score }}
    </span>
  </div>
</div>
